import store from "app/store/store";
import {
  competitionListTimeEnum,
  EuroOrderByOptions,
  ListRenderValues,
  MarketTypes,
  TabTypes,
} from "app/utils/const";
import dayjs from "dayjs";
export class AsianCompetitionHelper {
  static getAsianParams(
    rootState: Record<string, any>,
    payload: { fullList: boolean }
  ) {
    const fullList = payload.fullList;

    const {
      line,
      orderBy,
      selectedDate,
      asianPreGameEventsOnly,
      bookmarksOnly,
    } = rootState.asianCompetitionListFiltersModel;

    const selectedSportTimeFrame =
      rootState.sportsSelectionListModel.selectedSportTimeFrame;
    const before = this.getBeforeParam(selectedSportTimeFrame, selectedDate);
    const after = this.getAfterParam(
      selectedSportTimeFrame,
      selectedDate,
      asianPreGameEventsOnly
    );

    if (bookmarksOnly) {
      return {
        bookmarksOnly: true,
        orderBy: EuroOrderByOptions.ALPHABETICAL,
        after: dayjs().startOf("day").unix(),
        line,
        size: 180,
      };
    } else {
      return {
        size: fullList ? 180 : ListRenderValues.THRESHOLD,
        nbEventsByCompetition: 51,
        line,
        orderBy: this.getOrderBy(orderBy),
        marketType: this.getMarketType(
          rootState.sportsSelectionListModel.selectedMarketType
        ),
        navigationNodeIds: this.getNavigationNodeIds(),
        after,
        before,
        live: this.getAsianLiveNonLiveParams(
          asianPreGameEventsOnly,
          selectedSportTimeFrame
        ).live,
        nonLive: this.getAsianLiveNonLiveParams(
          asianPreGameEventsOnly,
          selectedSportTimeFrame
        ).nonLive,
        bookmarksOnly,
      };
    }
  }

  static getOrderBy(orderBy: string) {
    switch (orderBy) {
      case TabTypes.LIVE:
        return EuroOrderByOptions.LIVE;
      case TabTypes.POPULAR:
        return EuroOrderByOptions.POPULARITY;
      case TabTypes.ALL: // Euro uses ALL to get orderedBy date
        return EuroOrderByOptions.DATE;
      case "DATE": // Asian uses DATE to get orderedBy date
        return EuroOrderByOptions.DATE;
      default:
        return EuroOrderByOptions.POPULARITY;
    }
  }

  static endOfDay = dayjs().endOf("day").add(4.5, "hours").unix();

  static getBeforeParam(selectedSportTimeFrame, selectedDate) {
    if (selectedSportTimeFrame === competitionListTimeEnum.TODAY) {
      return this.endOfDay;
    } else if (
      selectedSportTimeFrame === competitionListTimeEnum.EARLY &&
      selectedDate !== TabTypes.ALL
    ) {
      const endOfSelectedDay = dayjs(selectedDate)
        .endOf("day")
        .add(4.5, "hours")
        .unix();
      return endOfSelectedDay;
    } else {
      return null;
    }
  }
  static getAfterParam(
    selectedSportTimeFrame,
    selectedDate,
    asianPreGameEventsOnly
  ) {
    if (
      selectedSportTimeFrame === competitionListTimeEnum.EARLY &&
      selectedDate === TabTypes.ALL
    ) {
      return this.endOfDay;
    } else if (
      selectedSportTimeFrame === competitionListTimeEnum.EARLY &&
      selectedDate !== TabTypes.ALL
    ) {
      const startOfSelectedDay = dayjs(selectedDate)
        .startOf("day")
        .add(4.5, "hours")
        .unix();
      return startOfSelectedDay;
    } else if (!asianPreGameEventsOnly) {
      return null;
    }
  }

  static getAsianLiveNonLiveParams(
    asianPreGameEventsOnly,
    selectedSportTimeFrame
  ) {
    // live, nonLive don't apply when EARLY selected
    if (selectedSportTimeFrame === competitionListTimeEnum.EARLY) {
      return { live: null, nonLive: null };
    }
    if (selectedSportTimeFrame === EuroOrderByOptions.LIVE.toUpperCase()) {
      return { live: true, nonLive: false };
    } else if (!asianPreGameEventsOnly) {
      return { live: true, nonLive: true };
    } else if (asianPreGameEventsOnly) {
      return { live: false, nonLive: true };
    } else {
      return { live: true, nonLive: true };
    }
  }

  /**
   * In asian view, navigationNodeIds are set by
   * -  Selecting a sport in the Sports Selection Box - sportNavNodeId
   * -  Selecting one or more competitions using the Leagues Selector button - selectedComps,
   * -  Selecting a competition from search results - singleSelectedCompetitionId,
   * -  Clicking on the competition name, in the list of competitions- singleSelectedCompetitionId
   * @returns string
   */

  static getNavigationNodeIds(): string {
    const sportNavNodeId =
      store.getState().sportsSelectionListModel.sportNavNodeId;

    const singleSelectedCompetitionId =
      store.getState().asianCompetitionListFiltersModel
        .singleSelectedCompetitionId;
    const selectedCompetitionIds =
      store.getState().asianCompetitionListFiltersModel.selectedCompetitionIds;
    if (singleSelectedCompetitionId) {
      return singleSelectedCompetitionId;
    }
    if (selectedCompetitionIds && selectedCompetitionIds.length > 0) {
      return `${sportNavNodeId},${selectedCompetitionIds}`;
    } else {
      return sportNavNodeId;
    }
  }
  static getMarketType(marketType: string): string | null {
    // When HDP & O/U markets are selected, marketType is set to HANDICAP
    // In order to load HDP & O/U markets, don't send marketType param, ie set it to null
    if (marketType === MarketTypes.HANDICAP) {
      return null;
    } else {
      return marketType;
    }
  }
}
